import Vue from 'vue'
import Router from 'vue-router'
// 引入组件（方式一）
import BabyTools from "../components/BabyTools.vue";
import Login from "@/components/Login.vue";
import EventTrack from "@/components/EventTrack.vue";
import EventBoard from "@/components/EventBoard.vue";

//解决vue-router 3.0以上 重复路由报错的问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

const constantRoutes = [
    {
        path:'/',
        component: BabyTools
    },
    {
        path:'/wxsupermam.html',
        component: BabyTools
    },
    {
        path:'/supermam/login',
        component: Login
    },
    {
        path:'/supermam/eventTrack',
        component: EventTrack
    },
    {
        path:'/supermam/eventBoard',
        component: EventBoard
    }
]
export default new Router({
    routes: constantRoutes,
    mode: 'history' // 不显示#
})
